import { useMemo } from 'react';
import { Box } from '@mui/material';

const TableAndEmplyeeInfo = ({ orderMetaData, metadata }) => {
  const memoData = useMemo(() => {
    const tableNumber =
      metadata?.tableDetails?.tableDetails?.name || orderMetaData?.tableNumber;
    const employeeInitials =
      metadata?.tableDetails?.tableDetails?.employeeInfo?.initials ||
      orderMetaData?.employeeInitials;

    return {
      tableNumber: tableNumber || '',
      employeeInitials: employeeInitials || '',
    };
  }, [orderMetaData, metadata]);

  return (
    <Box>
      {memoData?.tableNumber ? (
        <div className="order-date">
          <small className="mr-1">Table:&nbsp;</small>
          <p className="text">{memoData?.tableNumber}</p>
        </div>
      ) : null}
      {memoData?.employeeInitials ? (
        <div className="order-date">
          <small className="mr-1">Employee:&nbsp;</small>
          <p className="text">{memoData?.employeeInitials} </p>
        </div>
      ) : null}
    </Box>
  );
};

export default TableAndEmplyeeInfo;
